import type { Epic } from 'Flux/index.js'
import { projectSlice } from 'Flux/Slice/Project/ProjectSlice.js'
import { catchError, filter, mergeMap, of, switchMap, withLatestFrom } from 'rxjs'
import type { ProjectOrder } from '../../../Model/Project/IProjectSample.js'

export const GetProjectOrdersEpic: Epic = (action$, state$, { [projectSlice.name]: project, ProjectRepository }) =>
  action$.pipe(
    filter(project.loadProjectOrdersRequest.match),
    withLatestFrom(state$),
    // `projectOrdersProjectId` is set by the request, so only the latest request's answer may land.
    switchMap(([action]) => {
      return ProjectRepository.fetchProjectOrders(action.payload.projectId).pipe(
        mergeMap((response: ProjectOrder[]) => of(project.loadProjectOrdersRequestSuccess(response))),
        catchError((error) => of(project.loadProjectOrdersRequestFailure({ error })))
      )
    })
  )
